import { render } from "./CheckoutBasket.vue?vue&type=template&id=e5294922"
import script from "./CheckoutBasket.vue?vue&type=script&lang=js"
export * from "./CheckoutBasket.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__